module.exports = __webpack_public_path__ + "res/ic_zero_slash_m.0ea8384523ba223c8a11a8758b4b6068.png";